module.exports = __webpack_public_path__ + "static/media/ไดคัทสี่เหลี่ยม-01.ffc53e7f.png";